export class Device {
  id: string;
  name: string;
  ipv4Address: string;
  registrationDate: string;
}
